import type { ReactNode } from 'react';

import CodeSnippet from '@zen/Components/CodeSnippet';
import { Counter, Tooltip } from '@zen/DesignSystem';

export const formatHsCodes = (hsCodes: string): ReactNode => {
  if (!hsCodes) return '-';

  const splitHsCodes = hsCodes.split(',');

  const firstTariffCode = splitHsCodes[0];
  const hasMoreThanOneTariffCode: boolean = splitHsCodes.length > 1;
  const tooltipCounter: number = splitHsCodes.length - 1;
  const tooltipContent = splitHsCodes.slice(1).map((hsCode) => (
    <div key={hsCode} className="font-mono">
      {hsCode}
    </div>
  ));

  return (
    <div className="flex items-center justify-start">
      <CodeSnippet>{firstTariffCode}</CodeSnippet>
      {hasMoreThanOneTariffCode && (
        <Tooltip tooltipContent={tooltipContent}>
          <div className="pl-4">
            <Counter prefix="+" showCounterLimit={false} value={tooltipCounter} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};
